// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Login.css */
.base-login {
    background-color: #303030; /* Dark background for contrast */
    height: 100vh; /* Full viewport height */
    display: flex; /* Flexbox for centering */
    justify-content: center; /* Center horizontally */
    align-items: center; /* Center vertically */
    text-align: center; /* Center text */
}

.login-container {
    background-color: white; /* White background for the container */
    padding: 20px;
    border-radius: 10px;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
    width: 23%;
    max-width: 350px;
}

h2 {
    text-align: center; /* Center heading */
    color: #333; /* Darker text for better contrast */
    margin-bottom: 20px; /* Space below heading */
}

.form-group {
    margin-bottom: 20px; /* Increased space between form groups */
    display: flex; /* Use flexbox for alignment */
    flex-direction: column; /* Stack label and input vertically */
    align-items: center; /* Center items horizontally */
}

label {
    display: block; /* Block display for labels */
    margin-bottom: 5px; /* Space below labels */
    color: #555; /* Slightly lighter color for labels */
}

input {
    width: 90%; /* Full width inputs */
    max-width: 100%; /* Ensure it doesn't exceed container width */
    padding: 12px; /* Increased padding for comfort */
    border: 1px solid #ccc; /* Light border */
    border-radius: 4px; /* Rounded corners */
    font-size: 16px; /* Larger font size for readability */
    transition: border-color 0.3s; /* Smooth transition for focus */
}

input:focus {
    border-color: #007bff; /* Change border color on focus */
    outline: none; /* Remove default outline */
}

.login-button {
    margin-top: 50px;
    width: 100%; /* Full width button */
    padding: 12px; /* Increased padding for comfort */
    background-color: #007bff; /* Bootstrap primary color */
    color: white; /* White text */
    border: none; /* No border */
    border-radius: 4px; /* Rounded corners */
    cursor: pointer; /* Pointer cursor on hover */
    font-size: 16px; /* Larger font size */
    transition: background-color 0.3s; /* Smooth transition for hover */
}

.login-button:hover {
    background-color: #0056b3; /* Darker blue on hover */
}

.error {
    color: red; /* Red color for error messages */
    text-align: center; /* Center error messages */
    margin-top: 10px; /* Space above error messages */
}

/* Add to existing Login.css */
.auth-switch {
    margin-top: 20px;
    text-align: center;
}

.auth-switch span {
    color: #007bff;
    cursor: pointer;
    margin-left: 5px;
    text-decoration: underline;
}

.auth-switch span:hover {
    color: #0056b3;
}

.forgot-password-link {
  text-align: right;
  margin-top: -5px;
  margin-bottom: 15px;
}

.forgot-password-link span {
  color: #007bff; /* atau warna tema sistem abang */
  font-size: 0.85rem;
  cursor: pointer;
  transition: color 0.2s;
}

.forgot-password-link span:hover {
  text-decoration: underline;
  color: #0056b3;
}

/* Responsive Design */
@media (max-width: 768px) {
    .login-container {
        padding: 25px;
        width: 90%;
    }
    
    .login-container h2 {
        font-size: 30px;
    }
    
    .form-group input {
        padding: 10px;
        font-size: 20px;
    }
    
    .login-button {
        padding: 10px;
        font-size: 20px;
        height: 50px;
    }
    
    label {
        font-size: 18px;
    }
}`, "",{"version":3,"sources":["webpack://./src/components/Login.css"],"names":[],"mappings":"AAAA,cAAc;AACd;IACI,yBAAyB,EAAE,iCAAiC;IAC5D,aAAa,EAAE,yBAAyB;IACxC,aAAa,EAAE,0BAA0B;IACzC,uBAAuB,EAAE,wBAAwB;IACjD,mBAAmB,EAAE,sBAAsB;IAC3C,kBAAkB,EAAE,gBAAgB;AACxC;;AAEA;IACI,uBAAuB,EAAE,uCAAuC;IAChE,aAAa;IACb,mBAAmB;IACnB,wCAAwC;IACxC,UAAU;IACV,gBAAgB;AACpB;;AAEA;IACI,kBAAkB,EAAE,mBAAmB;IACvC,WAAW,EAAE,oCAAoC;IACjD,mBAAmB,EAAE,wBAAwB;AACjD;;AAEA;IACI,mBAAmB,EAAE,wCAAwC;IAC7D,aAAa,EAAE,8BAA8B;IAC7C,sBAAsB,EAAE,qCAAqC;IAC7D,mBAAmB,EAAE,8BAA8B;AACvD;;AAEA;IACI,cAAc,EAAE,6BAA6B;IAC7C,kBAAkB,EAAE,uBAAuB;IAC3C,WAAW,EAAE,sCAAsC;AACvD;;AAEA;IACI,UAAU,EAAE,sBAAsB;IAClC,eAAe,EAAE,6CAA6C;IAC9D,aAAa,EAAE,kCAAkC;IACjD,sBAAsB,EAAE,iBAAiB;IACzC,kBAAkB,EAAE,oBAAoB;IACxC,eAAe,EAAE,qCAAqC;IACtD,6BAA6B,EAAE,gCAAgC;AACnE;;AAEA;IACI,qBAAqB,EAAE,iCAAiC;IACxD,aAAa,EAAE,2BAA2B;AAC9C;;AAEA;IACI,gBAAgB;IAChB,WAAW,EAAE,sBAAsB;IACnC,aAAa,EAAE,kCAAkC;IACjD,yBAAyB,EAAE,4BAA4B;IACvD,YAAY,EAAE,eAAe;IAC7B,YAAY,EAAE,cAAc;IAC5B,kBAAkB,EAAE,oBAAoB;IACxC,eAAe,EAAE,4BAA4B;IAC7C,eAAe,EAAE,qBAAqB;IACtC,iCAAiC,EAAE,gCAAgC;AACvE;;AAEA;IACI,yBAAyB,EAAE,yBAAyB;AACxD;;AAEA;IACI,UAAU,EAAE,iCAAiC;IAC7C,kBAAkB,EAAE,0BAA0B;IAC9C,gBAAgB,EAAE,+BAA+B;AACrD;;AAEA,8BAA8B;AAC9B;IACI,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,0BAA0B;AAC9B;;AAEA;IACI,cAAc;AAClB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,cAAc,EAAE,iCAAiC;EACjD,kBAAkB;EAClB,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,0BAA0B;EAC1B,cAAc;AAChB;;AAEA,sBAAsB;AACtB;IACI;QACI,aAAa;QACb,UAAU;IACd;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,aAAa;QACb,eAAe;IACnB;;IAEA;QACI,aAAa;QACb,eAAe;QACf,YAAY;IAChB;;IAEA;QACI,eAAe;IACnB;AACJ","sourcesContent":["/* Login.css */\n.base-login {\n    background-color: #303030; /* Dark background for contrast */\n    height: 100vh; /* Full viewport height */\n    display: flex; /* Flexbox for centering */\n    justify-content: center; /* Center horizontally */\n    align-items: center; /* Center vertically */\n    text-align: center; /* Center text */\n}\n\n.login-container {\n    background-color: white; /* White background for the container */\n    padding: 20px;\n    border-radius: 10px;\n    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n    width: 23%;\n    max-width: 350px;\n}\n\nh2 {\n    text-align: center; /* Center heading */\n    color: #333; /* Darker text for better contrast */\n    margin-bottom: 20px; /* Space below heading */\n}\n\n.form-group {\n    margin-bottom: 20px; /* Increased space between form groups */\n    display: flex; /* Use flexbox for alignment */\n    flex-direction: column; /* Stack label and input vertically */\n    align-items: center; /* Center items horizontally */\n}\n\nlabel {\n    display: block; /* Block display for labels */\n    margin-bottom: 5px; /* Space below labels */\n    color: #555; /* Slightly lighter color for labels */\n}\n\ninput {\n    width: 90%; /* Full width inputs */\n    max-width: 100%; /* Ensure it doesn't exceed container width */\n    padding: 12px; /* Increased padding for comfort */\n    border: 1px solid #ccc; /* Light border */\n    border-radius: 4px; /* Rounded corners */\n    font-size: 16px; /* Larger font size for readability */\n    transition: border-color 0.3s; /* Smooth transition for focus */\n}\n\ninput:focus {\n    border-color: #007bff; /* Change border color on focus */\n    outline: none; /* Remove default outline */\n}\n\n.login-button {\n    margin-top: 50px;\n    width: 100%; /* Full width button */\n    padding: 12px; /* Increased padding for comfort */\n    background-color: #007bff; /* Bootstrap primary color */\n    color: white; /* White text */\n    border: none; /* No border */\n    border-radius: 4px; /* Rounded corners */\n    cursor: pointer; /* Pointer cursor on hover */\n    font-size: 16px; /* Larger font size */\n    transition: background-color 0.3s; /* Smooth transition for hover */\n}\n\n.login-button:hover {\n    background-color: #0056b3; /* Darker blue on hover */\n}\n\n.error {\n    color: red; /* Red color for error messages */\n    text-align: center; /* Center error messages */\n    margin-top: 10px; /* Space above error messages */\n}\n\n/* Add to existing Login.css */\n.auth-switch {\n    margin-top: 20px;\n    text-align: center;\n}\n\n.auth-switch span {\n    color: #007bff;\n    cursor: pointer;\n    margin-left: 5px;\n    text-decoration: underline;\n}\n\n.auth-switch span:hover {\n    color: #0056b3;\n}\n\n.forgot-password-link {\n  text-align: right;\n  margin-top: -5px;\n  margin-bottom: 15px;\n}\n\n.forgot-password-link span {\n  color: #007bff; /* atau warna tema sistem abang */\n  font-size: 0.85rem;\n  cursor: pointer;\n  transition: color 0.2s;\n}\n\n.forgot-password-link span:hover {\n  text-decoration: underline;\n  color: #0056b3;\n}\n\n/* Responsive Design */\n@media (max-width: 768px) {\n    .login-container {\n        padding: 25px;\n        width: 90%;\n    }\n    \n    .login-container h2 {\n        font-size: 30px;\n    }\n    \n    .form-group input {\n        padding: 10px;\n        font-size: 20px;\n    }\n    \n    .login-button {\n        padding: 10px;\n        font-size: 20px;\n        height: 50px;\n    }\n    \n    label {\n        font-size: 18px;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
